import { getCountries } from "react-phone-number-input";

const supportedCodes = new Set(getCountries());

export const normalizeCountriesResponse = (response) => {
  const rows = response?.data?.data?.countries;
  if (response?.data?.success === false || !Array.isArray(rows)) {
    throw new Error("Unable to load countries");
  }

  const byCode = {};
  const countries = [];
  for (const row of rows) {
    const code = String(row?.code || "").trim().toUpperCase();
    const name = typeof row?.name === "string" ? row.name.trim() : "";
    const dialCode = String(row?.dial_code ?? "").trim().replace(/^\+/, "");
    if (!/^[A-Z]{2}$/.test(code) || !name || !/^\d+$/.test(dialCode) ||
        row?.id == null || byCode[code]) continue;

    const country = {
      id: String(row.id),
      value: code,
      code,
      name,
      dialCode,
      flagSrc: typeof row.image === "string" ? row.image : null,
      searchCode: code.toLowerCase(),
      searchName: name.toLowerCase(),
    };
    byCode[code] = country;
    // Keep API order, but only offer countries supported by the phone parser.
    if (supportedCodes.has(code)) countries.push(country);
  }

  return { countries, byCode, codes: countries.map((country) => country.code) };
};

export const getCountryIdByIsoCode = (countryCode, byCode = {}) =>
  byCode[String(countryCode || "").toUpperCase()]?.id || "";
